<template>
  <div style="padding: 10px;">
    <!-- 面包区 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/orgList' }">合作社列表</el-breadcrumb-item>
      <el-breadcrumb-item><a href="/paymentExamine">资金支付情况表</a></el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片区 -->
    <cl-card>
      <el-row class="renovate">
        <!-- 刷新数据按键 -->
        <el-col>
          <template #tools>
            <el-button @click="getExamineONPC()" icon="el-icon-refresh" type="text" style="font-size: 20px;">
            </el-button>
          </template>
          <el-button type="primary" plain @click="getExamineONPC()">刷新数据</el-button>
        </el-col>

      </el-row>

      <!-- 列表区 -->
      <el-table
          :data="tableData"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          border stripe>
          <el-table-column prop="DbAccName" label="发起机构" width="180"></el-table-column>
          <el-table-column prop="CrAccName" label="收款对象"></el-table-column>
          <el-table-column label="支付金额">
            <template slot-scope="scope">
              <span>{{ scope.row.Amt }} 元</span>
            </template>
          </el-table-column>
          <el-table-column prop="paymentTime" label="支付时间">
           <template slot-scope="scope">
              <span>{{ scope.row.paymentTime | showDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Postscript" label="附言"></el-table-column>
          <el-table-column prop="WhyUse" label="用途"></el-table-column>
          <el-table-column prop="payStatus" label="支付状态">
            <template slot-scope="scope">
               <span v-if="scope.row.payStatus == paymentStatus[0].key"
                 :style="{color:paymentStatus[0].color}">{{paymentStatus[0].lable}}</span>
               <span v-if="scope.row.payStatus == paymentStatus[1].key"
                 :style="{color:paymentStatus[1].color}">{{paymentStatus[1].lable}}</span>
               <span v-if="scope.row.payStatus == paymentStatus[2].key"
                 :style="{color:paymentStatus[2].color}">{{paymentStatus[2].lable}}</span>
               <span v-if="scope.row.payStatus == paymentStatus[3].key"
                 :style="{color:paymentStatus[3].color}">{{paymentStatus[3].lable}}</span>
               <span v-if="scope.row.payStatus == paymentStatus[4].key"
                 :style="{color:paymentStatus[4].color}">{{paymentStatus[4].lable}}</span>
               <span v-if="scope.row.payStatus == paymentStatus[5].key"
                 :style="{color:paymentStatus[5].color}">{{paymentStatus[5].lable}}</span>
               <span v-if="scope.row.payStatus == paymentStatus[6].key"
                 :style="{color:paymentStatus[6].color}">{{paymentStatus[6].lable}}</span>
               <span v-if="scope.row.payStatus == paymentStatus[7].key"
                 :style="{color:paymentStatus[7].color}">{{paymentStatus[7].lable}}</span>
             </template>
          </el-table-column>
          <el-table-column prop="paymentResult" label="支付结果"></el-table-column>
        </el-table>
    </cl-card>
    <!-- 分页区域 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
        :current-page="queryParms.page"
        :page-sizes="[2, 3, 5, 8, 10, 20]"
        :page-size="queryParms.count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryParms.total">
      </el-pagination>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getExamineListONPCBank } from '@/api/user'
import { formatDate } from '@/utils/utislDate'
export default {
  name: 'shareExamPage',
  data() {
    return {
      tableLoading: false,
      paymentStatus: [
        {
          key: -3,
          lable: '支付异常',
          color: '#f56c6c'
        },
        {
          key: -2,
          lable: '审批撤销',
          color: '#E6A23C'
        },
        {
          key: -1,
          lable: '审批不通过',
          color: '#f56c6c'
        },
        {
          key: 0,
          lable: '审核中',
          color: '#909399'
        },
        {
          key: 1,
          lable: '待支付',
          color: '#409eff'
        },
        {
          key: 2,
          lable: '支付中',
          color: '#909399'
        },
        {
          key: 3,
          lable: '已支付',
          color: '#67c23a'
        },
        {
          key: 4,
          lable: '支付失败',
          color: '#f56c6c'
        }
      ],
      examTypeList: [],
      examStepList: [],
      tableData: [],
      activeName: '999',
      activeType: '999',
      payActiveName: '1',
      queryParms: {
        setOrgId: '',
        types: [9],
        status: undefined,
        count: 8,
        page: 1,
        offset: 0,
        total: 0
      }
    }
  },
  computed: {
    ...mapState({
      orgInfo: (state) => state.orgInfo.orgInfo
    })
  },
  methods: {
    // 监听每页显示条数的事件
    handleSizeChange (newSize) {
      this.queryParms.count = newSize
      this.getExamineONPC()
    },
    // 监听选择了第几页的事件
    handleCurrentChange (newPage) {
      this.queryParms.page = newPage
      this.getExamineONPC()
    },
    getAmt(row) {
      // debugger
      // var data = JSON.parse(row)
      // return this.$commen.formatMoney(data)
    },
    typeFilter({
      cellValue
    }) {
      const familyType = this.$constData.shareExamineType
      let str = ''
      familyType.forEach(item => {
        if (item.key === cellValue) {
          str = item.val
          return str
        }
      })
      return str
    },
    userFilter({
      cellValue
    }) {
      let str = ''
      const data = JSON.parse(cellValue).oldData
      str = data.userName
      return str
    },
    timeFilter({
      cellValue
    }) {
      const timeData = new Date(cellValue)
      const timer = this.$commen.dateTimeFliter(timeData, 0, true, true)
      return timer
    },
    setTyps(item) {
      // this.queryParms.types = [item.key]
      this.getExamineONPC()
    },
    getExamineONPC() {
      debugger
      this.tableData = []
      this.tableLoading = true
      this.queryParms.offset = (this.queryParms.page - 1) * this.queryParms.count
      getExamineListONPCBank(this.queryParms).then(res => {
        this.tableLoading = false
        debugger
        if (res.status !== 200) return this.$message.error('错误，有可能是参数异常，或者服务器没有响应！！！')
        const data1 = res.data.c.data
        if (res.data.c === 'invalid token') {
          this.$router.push('/login')
          this.$message.error('登录已失效，请重新登录')
          return
        }
        if (data1.length === 0) return this.$message.error('没有找到符合条件的数据')
        if (res.status === 200) {
          this.tableData = data1
          this.queryParms.total = res.data.c.total
        }
      })
    }
  },
  created() {
    debugger
    this.queryParms.setOrgId = JSON.parse(localStorage.getItem('setOrgId'))
    // this.initExamTypeData()
    this.getExamineONPC()
  },
  filters: {
    // 将时间戳改成日期格式
    showDate: function (value) {
      const date1 = new Date(value)
      return formatDate(date1, 'yyyy年MM月dd日 hh:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
/*  .el-table{
    top: 0.625rem;
  } */
  .el-row{
    display: flex;
    justify-content: space-between;
  }
  .renovate{
    justify-content: right;
  }
</style>
